import { render, staticRenderFns } from "./GovernateAdd.vue?vue&type=template&id=0ba2d391&scoped=true&"
import script from "./GovernateAdd.vue?vue&type=script&lang=js&"
export * from "./GovernateAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba2d391",
  null
  
)

export default component.exports